// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"9e4c1336","453":"ed1181ac","484":"2ce9db79","551":"a3e0349d","672":"7085288d","842":"20a12ccb","869":"d7f193ef","974":"1dd3241a"}[chunkId] + ".chunk.js";
};